import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormGroup, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class PasswordValidationService {
  static matchPassword(AC: AbstractControl): ValidatorFn | ValidatorFn[] | null | undefined {
    const nuevoPassword = AC.get('nuevoPassword');
    const repeatPassword = AC.get('confirmarPassword');

    if (repeatPassword?.errors && !repeatPassword.hasError('matchPassword')) {
      return;
    }

    // set error on matchingControl if validation fails
    if (nuevoPassword?.value === repeatPassword?.value) {
      repeatPassword?.setErrors(null);
    } else {
      repeatPassword?.setErrors({ matchPassword: true });
    }

    return null;
  }

  static mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: UntypedFormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.hasError('mustMatch')) {
        return;
      }

      // set error on matchingControl if validation fails
      if (control.value === matchingControl.value) {
        matchingControl.setErrors(null);
      } else {
        matchingControl.setErrors({ mustMatch: true });
      }
      return null;
    };
  }
}
